import { Routes } from '@angular/router';
import { AppVersionListComponent } from '@adm-web-app/modules/app-versions/list/list.component';

export const appVersionsRoutes: Routes = [
  {
    path: '', component: AppVersionListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
];
